export const getRuntimeDisplayLabel = (runtimeDays: number) => {
  if (runtimeDays < 60) {
    return `${runtimeDays}d`;
  }

  if (runtimeDays < 365) {
    return `${Math.round(runtimeDays / 30)}mo`;
  }

  let years = Math.floor(runtimeDays / 365);
  let months = Math.round((runtimeDays % 365) / 30);

  if (months === 12) {
    years += 1;
    months = 0;
  }

  return months > 0 ? `${years}y ${months}mo` : `${years}y`;
};
